// extracted by mini-css-extract-plugin
export default {"button":"back-button_button__8EExw"};